module.exports = __webpack_public_path__ + "img/1-mob-wide.89ac5a13.png";